<template>
    <div :class="'form-group' + cols">
        <label for="birthday">{{ label }} *</label>
        <input type="text" :name="name" value="" v-model="date" id="birthday">
        <!--

        <flat-pickr
                v-model="fields.birthday"
                :config="birthdayConfig"
                class="form-control"
                placeholder="Geburtsdatum"
                name="consumer[birthday]"
                @on-change="validateBirthday">
        </flat-pickr>
        -->
        <datepicker :config="config"></datepicker>
    </div>
</template>

<script>
    import Flatpickr from "flatpickr";
    //import 'flatpickr/dist/flatpickr.css';
    //import {German} from "flatpickr/dist/l10n/de.js"

    export default {
        name: "Flatpickr",
        props: ['cols', 'label', 'name'],
        data(){
            return {
                date: "",
                config: {
                    allowInput: true
                }
            };
        },
        mounted(){

        }
    }
</script>

<style scoped>

</style>